module.exports = __webpack_public_path__ + "img/dash-card-icon-2.7e47d368.svg";